import { createSlice } from '@reduxjs/toolkit';
import { createApprovalLineState } from '../Scripts/Permit/M_PER_CUSTOM/utils/approvalLine';
import { PERMIT_INITIAL_DATA } from './../Scripts/Permit/PermitSchemas';

const initialState = {
  selectedFilter: '전체',
  permitAlarm: '',
  searchRequestId: 0,
  filterLabels: [
    '전체',
    '결재요청',
    '결재완료',
    '결재대기',
    '대기',
    '반려',
    '승인요청',
    '승인',
    '만료',
    '연장요청',
    '연장대기',
    '연장반려',
    '입회요청',
    '입회중',
    '입회완료',
    '작업완료',
  ],
  depApproval: [],
  approvalLine: createApprovalLineState(),
  extendData: {},
  calendarDots: [],
  baseInfo: {},
  codeInfo: {},
  mode: '',
};

const permitSlice = createSlice({
  name: 'permit',
  initialState,
  reducers: {
    setSelectedFilter(state, action) {
      state.selectedFilter = action.payload ?? '전체';
    },
    requestSearch(state) {
      state.searchRequestId += 1;
    },
    setPermitAlarm(state, action) {
      state.permitAlarm = action.payload ?? '';
    },
    setDepApproval(state, action) {
      state.depApproval = action.payload ?? [];
    },
    setExtendData(state, action) {
      state.extendData = action.payload ?? {};
    },
    clearPermitAlarm(state) {
      state.permitAlarm = '';
    },
    resetPermitFilters(state) {
      state.selectedFilter = '전체';
    },
    updateBaseInfoField(state, action) {
      const { name, value } = action.payload;
      state.baseInfo[name] = value;
    },
    setBaseInfo(state, action) {
      state.baseInfo = { ...state.baseInfo, ...action.payload };
    },
    setCodeInfo(state, action) {
      state.codeInfo = { ...state.codeInfo, ...action.payload };
    },
    setCalendarDots(state, action) {
      state.calendarDots = action.payload ?? [];
    },
    resetPermitForm(state, action) {
      const version = action.payload || 'CUSTOM';
      const data = PERMIT_INITIAL_DATA[version];

      state.baseInfo = data.baseInfo;
      state.codeInfo = data.codeInfo;
      state.approvalLine = createApprovalLineState();
      state.mode = '';
    },
    initializeApprovalLine(state, action) {
      if (state.approvalLine.touched) return;
      state.approvalLine = {
        ...createApprovalLineState(),
        ...(action.payload ?? {}),
        initialized: true,
        touched: false,
      };
    },

    setApprovalLine(state, action) {
      state.approvalLine = {
        ...state.approvalLine,
        ...(action.payload ?? {}),
        smId:
          action.payload?.smId ??
          action.payload?.safetyManager?.smId ??
          state.approvalLine.smId ??
          '',
        touched: true,
      };
    },

    resetApprovalLine(state) {
      state.approvalLine = createApprovalLineState();
    },

    setMode: (state, action) => {
      state.mode = action.payload; // 'write', 'signDep', 'signSm', 'view' 등
    },

    setAllInfo: (state, action) => {
      state.baseInfo = action.payload.baseInfo;
      state.codeInfo = action.payload.codeInfo;
    },
    resetBaseInfo(state) {
      state.baseInfo = {};
      state.codeInfo = {};
    },
  },
});

export const PermitActions = permitSlice.actions;
export default permitSlice.reducer;
